import { setMode } from '@stencil/core';
// Element with Property "mode"
setMode(customElement => {
  const element = customElement;
  if (!element.mode)
    element.setAttribute('mode', 'default');
  return element.mode;
});
//# sourceMappingURL=global.js.map
